import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { api } from "../../../urls";

import { SendReview } from "../../common/SendReview";
import { FavoriteProfile } from "../../common/FavoriteProfile";
import { MessageContent } from "../../Message/MessageContent";
import { PhoneIcon } from "../../../assets/image/PhoneIcon";
import { ServiceIcon } from "../../../assets/image/ServiceIcon";
import { SearchIcon } from "../../../assets/image/SearchIcon";
import { MarkRoundIcon } from "../../../assets/image/MarkRoundIcon";
import { CrownIcon } from "../../../assets/image/CrownIcon";
import { ConfirmIcon } from "../../../assets/image/ConfirmIcon";
import {
  ENG_LANGUAGE,
  MONTH_ENG_LANGUAGE,
  MONTH_SRB_LANGUAGE,
} from "../../../utils/variables";
import { InterviewItem } from "./InterviewItem";
import { InterviewSection } from "./InterviewSection";
import { useNotification } from "../../Notifications/NotificationsContext";

import { TestimonialsForm } from '../../Testimonials/TestimonialsForm';

import { submitTestimonialsForm } from "../../../api";

import styles from './InterviewAccept.module.css';
import {JobCard} from "../../Job/JobApplicationDetail/JobCard";

export function InterviewAccept(props) {

  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [providerData, setProviderData] = useState([]);
  const [providerDataCard, setProviderDataCard] = useState([]);
  const [isCheck, setIsCheck] = useState(true);
  const [rate, setRate] = useState({});
  const [update, setUpdate] = useState(false);
  const [profile] = useState();
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [view, setView] = useState("");
  const [isElement, setIsElement] = useState(true);
  const [showTestimonialsModal, setShowTestimonialsModal] = useState(false);
  const [message, setMessage] = useState("");
  const [hire, setHire] = useState("");
  const [statusTestimonialsMessage, setStatusTestimonialsMessage] = useState("");
  const month =
    language === ENG_LANGUAGE ? MONTH_ENG_LANGUAGE : MONTH_SRB_LANGUAGE;
  const [jobData, setJobData] = useState({});

  const handleElementById = (e, x, z) => {
    document.getElementById(e).style.display = "none";
    document.getElementById(x).style.display = "block";
    if (isElement) {
      if (document.getElementById(z)) {
        document.getElementById(z).style.display = "block";
      }
      setIsElement(false);
    } else {
      setIsElement(true);
      if (document.getElementById(z)) {
        document.getElementById(z).style.display = "none";
      }
    }
  };
  const { updateNotificationCount } = useNotification();

  const fetchProviderData = () => {
    const myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      notification_id: props.id,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(api + "/api/v1/interviewinvitesresponseprofile", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setProviderData([result.data.providerprofile]);
        let providerCard = result.data.providerprofile;
        providerCard.user_id = providerCard.provider_id;
        providerCard.Appjob_ID=providerCard.provider_id;
        providerCard.applyjob_hiredstatus = providerCard.hire_status;
        setProviderDataCard(providerCard);
        setMessage(result.data.currentUserName);
        setRate(result.data);
        setJobData({"jobstatus":result.data.jobStatus, "reviewAvg":result.data.reviewAvg, "reviewcount":result.data.reviewcount});
        updateNotificationCount();
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (isCheck) {
      fetchProviderData();
      setIsCheck(false);
    }
  }, [isCheck, hire]);

  const handleSubmit = (a) => {
    const myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      inv_id: props.id,
      provider_id: a,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(api + "/api/v1/providerhire", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.type == "success") {
          setHire("Hired Successfully");
          setShowTestimonialsModal(true);
          console.error('hired!');
          fetchProviderData();
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleTestimonialSubmit = async (formData) => {
    try {
      setShowTestimonialsModal(false);
      const result = await submitTestimonialsForm(formData);

      if (result.success) {
        setStatusTestimonialsMessage("testimonials.submit-success");
        setTimeout(() => setStatusTestimonialsMessage(""), 3000);
      }
      return result;
    } catch (error) {
      console.error("Error submitting testimonial form", error);
      alert(t("submit-error"));
      throw error;
    }
  };

  const handleCloseTestimonialsModal = () => {
    setShowTestimonialsModal(false);
  }


  return (
    <>
      {statusTestimonialsMessage && (
        <div className="popup_status" id="popup_status">
          {t('testimonials.confirmationText')}
        </div>
      )}

      {providerData && providerData[0] ? (
        view == "" ? (
          <>
            <h2 className="border"></h2>
            <div className="detail_invit">
              <p>
                {providerData &&
                  providerData[0] &&
                  providerData[0].read_status == 0 ? (
                  <span className="new">{t("text-new-up")}</span>
                ) : (
                  ""
                )}
                {providerData &&
                  providerData[0] &&
                  providerData[0].profile_headline != null
                  ? providerData &&
                  providerData[0] &&
                  providerData[0].profile_headline
                  : ""}
                <span className="date">
                  {new Date(
                    providerData &&
                    providerData[0] &&
                    providerData[0].created_at
                  ).toLocaleDateString("en-US", { weekday: "short" })}
                  ,
                  {month[
                    new Date(
                      providerData &&
                      providerData[0] &&
                      providerData[0].created_at
                    ).getMonth()
                  ] +
                    " " +
                    new Date(
                      providerData &&
                      providerData[0] &&
                      providerData[0].created_at
                    ).getDate()}
                  ,
                  {new Date(
                    providerData &&
                    providerData[0] &&
                    providerData[0].created_at
                  ).getFullYear()}
                  ,
                  {new Date(
                    providerData &&
                    providerData[0] &&
                    providerData[0].created_at
                  ).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </p>
              <h2>
                {t("text-dear")} <span>{message}</span>,
              </h2>
              <h2>
                {providerData && providerData[0] && providerData[0].status == 2
                  ? ""
                  : t("congratulations-with")}
                <Link
                  to={"/profile-provider/" + providerData[0]?.UID}
                  style={{
                    marginLeft:
                      providerData &&
                        providerData[0] &&
                        providerData[0].status == 2
                        ? "0"
                        : "5px",
                  }}
                >

                  {providerData &&
                    providerData[0] &&
                    providerData[0].first_name + " "}
                </Link>
                {providerData && providerData[0] && providerData[0].status == 1
                  ? t("text-accepted")
                  : providerData &&
                    providerData[0] &&
                    providerData[0].status == 2
                    ? t("text-declined")
                    : t("text-pending")}
                {" "}
                {t("interview-person-invite")}
              </h2>
              {providerData &&
                providerData[0] &&
                providerData[0].status == 2 ? (
                ""
              ) : (
                <p style={{ paddingTop: "15px" }}>
                  {t(
                    "next-step-interview"
                  ) + " "}
                  <Link to="/safety-center" target="_blank">
                    {t("safety-center")}
                  </Link>
                  {t("text-and")}
                  <Link to="/faq" target="_blank">
                    {t("text-faq")}
                  </Link>
                  .
                </p>
              )}
            </div>
            <div class="right_side_section jobapli">
              <div class="looking_for_candidate">
                {providerData.map((data, index) => {
                  return (

                        <JobCard
                            key={index}
                            index={index}
                            data={providerDataCard}
                            jobData={jobData}
                            hired={hire}
                            handleAcceptData={handleSubmit}
                            setView={setView}
                            profile={profile}
                            handleElementById={handleElementById}
                            providerData={providerData}
                        />

                  )})}
                <div className="mobile">
                  {providerData.map((data, index) => {
                    if (index <= 5) {
                      return (
                        <InterviewItem
                          data={data}
                          profile={profile}
                          index={index}
                          providerData={providerData}
                          hire={hire}
                          rate={rate}
                          setView={setView}
                          handleSubmit={handleSubmit}
                          handleElementById={handleElementById}
                        />
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )
      ) : (
        ""
      )}
      {view != "" ? (
        <div class="main-header">
          <MessageContent id={view} setview={setView} />
        </div>
      ) : (
        ""
      )}
      {showReviewModal ? (
        <Modal show={showReviewModal} onHide={(e) => setShowReviewModal(false)}>
          <Modal.Body>
            <SendReview
              setrequest={setShowReviewModal}
              slugdata={providerData && providerData[0] && providerData[0].UID}
              username={
                providerData &&
                providerData[0] &&
                providerData[0].first_name + " " + providerData &&
                providerData[0] &&
                providerData[0].last_name
              }
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      <Modal show={update} onHide={(e) => setUpdate(false)}>
        <Modal.Body>
          <div className="promocode_content login_first search_pop upgd">
            <Link to="" onClick={(e) => setUpdate(false)}>
              +
            </Link>
            <h2>
              {t(
                "post-full-benefits"
              )}
            </h2>
            <img src={window.location.origin + "/images/promo.png"} />
            <p>
              {t(
                "members-message-center"
              )}
            </p>
            <button onClick={(e) => setUpdate(false)} className={"ruf"}>
              <Link to={""}> {t("text-maybe-later")}</Link>
            </button>
            <button onClick={(e) => setUpdate(false)}>
              <Link to={""}>
                <CrownIcon />
                {t("upgrade-now")}
              </Link>
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showTestimonialsModal} onHide={handleCloseTestimonialsModal}>
        <Modal.Dialog>
          <Modal.Body>
            <div className={`${styles.testimonial_content}`}>
              <Link to="" onClick={handleCloseTestimonialsModal}>+</Link>
              <TestimonialsForm
                onSubmit={handleTestimonialSubmit}
                handleCloseTestimonialsModal={handleCloseTestimonialsModal}
              />
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </Modal>

    </>
  );
}
